var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Window',{attrs:{"window":this.meta}},[_c('template',{slot:"content"})],2)}
var staticRenderFns = []

export { render, staticRenderFns }